import Icon from "@mdi/react";
import { mdiShareVariant } from "@mdi/js";
import { handleShare } from "../services/common";
import { useLang } from "../services/lang";

export function ShareButton({ text, title, description }: { text?: string, title?: string, description?: string }) {
    const { dict } = useLang();
    return <a onClick={() => handleShare(title, description)}>
        <Icon path={mdiShareVariant} size={1} />
        {!text && <span className="no-mobile">{dict.share}</span>}
        {text && <span>{text}</span>}
    </a>;
}
